// Import all your images for card illusions
import englishImage from "../assets/svg/exampage/cardIllusions/english_dotoillution.svg";
import scoreImage from "../assets/svg/exampage/cardIllusions/score_dotoillution.svg";
import mathImage from "../assets/svg/exampage/cardIllusions/math_dotoillution.svg";
import witImage from "../assets/svg/exampage/cardIllusions/wit_dotoillution.svg";
import hotsImage from "../assets/svg/exampage/cardIllusions/hots_dotoillution.svg";

// Import all your banner images
import englishBannerImage from "../assets/svg/exampage/banners/english_banner.svg";
import scoreBannerImage from "../assets/svg/exampage/banners/score_banner.svg";
import mathBannerImage from "../assets/svg/exampage/banners/math_banner.svg";
import witBannerImage from "../assets/svg/exampage/banners/wit_banner.svg";
import hotsBannerImage from "../assets/svg/exampage/banners/hots_banner.svg";

export const EXAM_CONFIG = Object.freeze({
  names: {
    english: "English",
    score: "SCORE",
    "math olympiad": "Math Olympiad",
    "wizklub Intelligent Test": "wizklub intelligent test",
    "hots olympiad": "HOTS Olympiad",
    "i-emsat": "I-EMSAT",
    "career counselling": "Career Counselling",
    "score offline": "SCORE Offline",
    "genius semi-final": "Genius Semi-Final",
    "genius final": "Genius Final",
    "youth entrepreneurship challenge": "Youth Entrepreneurship Challenge",
    "score edge scholarship test": "score edge scholarship test",
    "revision test": "Revision Test",
    "atreya scholarship test": "Atreya Scholarship Test",
    "science olympiad": "Science Olympiad"
  },

  cardImages: {
    english: englishImage,
    score: scoreImage,
    "math olympiad": mathImage,
    "wizklub intelligent test": witImage,
    "hots olympiad": hotsImage,
    "i-emsat": englishImage,
    "career counselling": witImage,
    "score offline": englishImage,
    "genius semi-final": englishImage,
    "genius final": englishImage,
    "youth entrepreneurship challenge": witImage,
    "score edge scholarship test": scoreImage,
    "revision test": scoreImage,
    "atreya scholarship test": scoreImage,
    "science olympiad": hotsImage
  },

  bannerImages: {
    english: englishBannerImage,
    score: scoreBannerImage,
    "math olympiad": mathBannerImage,
    "wizklub intelligent test": witBannerImage,
    "hots olympiad": hotsBannerImage,
    "i-emsat": englishBannerImage,
    "career counselling": witBannerImage,
    "score offline": englishBannerImage,
    "genius semi-final": englishBannerImage,
    "genius final": englishBannerImage,
    "youth entrepreneurship challenge": witBannerImage,
    "score edge scholarship test": scoreBannerImage,
    "revision test": scoreBannerImage,
    "atreya scholarship test": scoreBannerImage,
    "science olympiad": hotsBannerImage
  },

  cssClasses: {
    english: "topcard-english",
    score: "topcard-score",
    "math olympiad": "topcard-math",
    "wizklub intelligent test": "topcard-wit",
    "hots olympiad": "topcard-hots",
    "i-emsat": "topcard-english",
    "career counselling": "topcard-wit",
    "score offline": "topcard-english",
    "genius semi-final": "topcard-english",
    "genius final": "topcard-english",
    "youth entrepreneurship challenge": "topcard-wit",
    "score edge scholarship test": "topcard-score",
    "revision test": "topcard-score",
    "athreya scholarship test": "topcard-score",
    "science olympiad": "topcard-hots"
  },

  reportConfig: {
    "youth entrepreneurship challenge": {
      showTestCompleted: false,
      showDownloadCertificate: false,
      showAdvanceReport: false,
      showTimer: false,
      showBuyReportBanner: false,
      showRank: false,
      showPercentile: false,
      showScore: true,
      showSubjectPerformance: false,
      showRewardsSection: false,
      showViewSolutions: false,
      redirectToAdvanceReport: false,
      advanceReportType: "none",
      showTopBanners: false
    },
    "career counselling": {
      showTestCompleted: true,
      showDownloadCertificate: false,
      showAdvanceReport: false,
      showTimer: false,
      showBuyReportBanner: false,
      showRank: false,
      showPercentile: false,
      showScore: false,
      showSubjectPerformance: true,
      showRewardsSection: true,
      showViewSolutions: true,
      redirectToAdvanceReport: false,
      advanceReportType: "none",
      showTopBanners: false
    },
    score: {
      showTestCompleted: true,
      showDownloadCertificate: true,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: true,
      showRewardsSection: true,
      showViewSolutions: true,
      redirectToAdvanceReport: true,
      advanceReportType: "internal",
      showTopBanners: false
    },
    "genius semi-final": {
      showTestCompleted: true,
      showDownloadCertificate: true,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: true,
      showRewardsSection: true,
      showViewSolutions: true,
      redirectToAdvanceReport: true,
      advanceReportType: "internal",
      showTopBanners: false
    },
    "genius final": {
      showTestCompleted: true,
      showDownloadCertificate: true,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: true,
      showRewardsSection: true,
      showViewSolutions: true,
      redirectToAdvanceReport: true,
      advanceReportType: "internal",
      showTopBanners: false
    },
    "hots olympiad": {
      showTestCompleted: true,
      showDownloadCertificate: true,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: false,
      showRewardsSection: true,
      showViewSolutions: true,
      redirectToAdvanceReport: true,
      advanceReportType: "external",
      externalReportRoute: "/olympaidreports",
      showTopBanners: false
    },
    "math olympiad": {
      showTestCompleted: true,
      showDownloadCertificate: true,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: false,
      showRewardsSection: true,
      showViewSolutions: true,
      redirectToAdvanceReport: true,
      advanceReportType: "external",
      externalReportRoute: "/olympaidreports",
      showTopBanners: false
    },
    "i-emsat": {
      showTestCompleted: true,
      showDownloadCertificate: true,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: true,
      showRewardsSection: true,
      showViewSolutions: true, // NEW
      redirectToAdvanceReport: true,
      advanceReportType: "external",
      externalReportRoute: "/iemsatreports",
      showTopBanners: false
    },
    "score offline": {
      showTestCompleted: true,
      showDownloadCertificate: true,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: true,
      showRewardsSection: true,
      showViewSolutions: true,
      redirectToAdvanceReport: true,
      advanceReportType: "internal",
      showTopBanners: false
    },
    english: {
      showTestCompleted: true,
      showDownloadCertificate: true,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: true,
      showRewardsSection: true,
      showViewSolutions: true,
      redirectToAdvanceReport: false,
      advanceReportType: "none",
      showTopBanners: false
    },
    "wizklub intelligent test": {
      showTestCompleted: true,
      showDownloadCertificate: true,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: true,
      showRewardsSection: true,
      showViewSolutions: true,
      redirectToAdvanceReport: false,
      advanceReportType: "external",
      externalReportRoute: "/olympaidreports",
      showTopBanners: false
    },
    "score edge scholarship test": {
      showTestCompleted: true,
      showDownloadCertificate: false,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: true,
      showRewardsSection: false,
      showViewSolutions: true,
      redirectToAdvanceReport: true,
      advanceReportType: "internal",
      sesBanner: true,
      showTalkToExpert: false,
      showTopBanners: false,
      showPIP: false
    },
    "atreya scholarship test": {
      showTestCompleted: true,
      showDownloadCertificate: false,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: true,
      showRewardsSection: false,
      showViewSolutions: true,
      redirectToAdvanceReport: true,
      advanceReportType: "internal",
      sesBanner: true,
      showTalkToExpert: false,
      showTopBanners: false,
      showPIP: false
    },
    "revision test": {
      showTestCompleted: true,
      showDownloadCertificate: true,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: true,
      showRewardsSection: true,
      showViewSolutions: true,
      redirectToAdvanceReport: true,
      advanceReportType: "internal",
      sesBanner: false,
      showTalkToExpert: true,
      showTopBanners: false
    },
    "science olympiad": {
      showTestCompleted: true,
      showDownloadCertificate: true,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: false,
      showRewardsSection: true,
      showViewSolutions: true,
      redirectToAdvanceReport: true,
      advanceReportType: "internal",
      showTopBanners: false
    },
    // Default configuration for other exams
    default: {
      showTestCompleted: true,
      showDownloadCertificate: true,
      showAdvanceReport: true,
      showTimer: true,
      showBuyReportBanner: true,
      showRank: true,
      showPercentile: true,
      showScore: true,
      showSubjectPerformance: true,
      showRewardsSection: true,
      showViewSolutions: true,
      redirectToAdvanceReport: false,
      advanceReportType: "none",
      sesBanner: false,
      showTalkToExpert: true,
      showTopBanners: false,
      showPIP: true
    }
  },

  // Advance report routing configuration
  advanceReportRouting: {
    score: "internal",
    geniussemifinal: "internal",
    geniusfinal: "internal",
    scoreoffline: "internal",
    hotsolympiad: "/olympaidreports",
    matholympiad: "/olympaidreports",
    iemsat: "/iemsatreports"
  }
});

// Helper functions
export const ExamConfigHelper = {
  getExamImage: (examName) => {
    const normalizedName = examName?.toLowerCase().trim();
    return EXAM_CONFIG.cardImages[normalizedName] || null;
  },

  getBannerImage: (examName) => {
    const normalizedName = examName?.toLowerCase().trim();
    return EXAM_CONFIG.bannerImages[normalizedName] || null;
  },

  getExamCssClass: (examName) => {
    const normalizedName = examName?.toLowerCase().trim();
    return EXAM_CONFIG.cssClasses[normalizedName] || null;
  },

  getDisplayName: (examName) => {
    const normalizedName = examName?.toLowerCase().trim();
    return EXAM_CONFIG.names[normalizedName] || examName;
  },

  isValidExam: (examName) => {
    const normalizedName = examName?.toLowerCase().trim();
    return normalizedName in EXAM_CONFIG.names;
  },

  // Report configuration helpers
  getReportConfig: (examName) => {
    const normalizedName = examName?.toLowerCase().trim();
    return EXAM_CONFIG.reportConfig[normalizedName] || EXAM_CONFIG.reportConfig.default;
  },

  shouldShowTestCompleted: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showTestCompleted;
  },

  shouldShowDownloadCertificate: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showDownloadCertificate;
  },

  shouldShowAdvanceReport: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showAdvanceReport;
  },

  shouldShowTimer: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showTimer;
  },

  shouldShowBuyReportBanner: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showBuyReportBanner;
  },

  shouldShowRank: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showRank;
  },

  shouldShowPercentile: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showPercentile;
  },

  shouldShowScore: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showScore;
  },

  shouldShowSubjectPerformance: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showSubjectPerformance !== undefined ? config.showSubjectPerformance : true;
  },

  shouldShowRewardsSection: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showRewardsSection !== undefined ? config.showRewardsSection : true;
  },

  shouldShowViewSolutions: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showViewSolutions !== undefined ? config.showViewSolutions : true;
  },

  getAdvanceReportRoute: (examName) => {
    const normalizedName = examName?.toLowerCase().replace(/[\s\W]+/g, "");
    return EXAM_CONFIG.advanceReportRouting[normalizedName] || null;
  },

  // Check if exam has external advance report
  hasExternalAdvanceReport: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.advanceReportType === "external";
  },

  // Get external report route
  getExternalReportRoute: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.externalReportRoute || null;
  },
  shouldShowSesBanner: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.sesBanner || null;
  },
  shouldShowTalkToExpert: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showTalkToExpert !== undefined ? config.showTalkToExpert : true;
  },

  shouldShowTopBanners: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showTopBanners !== undefined ? config.showTopBanners : true;
  },
  showPIP: (examName) => {
    const config = ExamConfigHelper.getReportConfig(examName);
    return config.showPIP !== undefined ? config.showPIP : true;
  }
};
